import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { EventSchedule } from '@/types';
import { TimePicker } from '@/components/ui/time-picker';

interface EditScheduleItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: Partial<Omit<EventSchedule, 'id' | 'event_id'>>) => void;
  item: EventSchedule | null;
  isLoading?: boolean;
}

export const EditScheduleItemModal: React.FC<EditScheduleItemModalProps> = ({
  isOpen,
  onClose,
  onSave,
  item,
  isLoading = false,
}) => {
  const [formData, setFormData] = React.useState<{
    hora: string;
    actividad: string;
  }>({
    hora: '',
    actividad: '',
  });

  // Update form data when item changes
  React.useEffect(() => {
    if (item) {
      setFormData({
        hora: item.hora,
        actividad: item.actividad,
      });
    }
  }, [item]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTimeChange = (time: string) => {
    setFormData((prev) => ({
      ...prev,
      hora: time,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Editar Actividad</DialogTitle>
            <DialogDescription>
              Actualiza los detalles de esta actividad en el cronograma.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <label htmlFor="hora" className="text-right text-sm font-medium">
                Hora
              </label>
              <div className="col-span-3">
                <TimePicker
                  time={formData.hora}
                  setTime={handleTimeChange}
                  disabled={isLoading}
                />
              </div>
            </div>
            <div className="grid grid-cols-4 items-center gap-4">
              <label htmlFor="actividad" className="text-right text-sm font-medium">
                Actividad
              </label>
              <Input
                id="actividad"
                name="actividad"
                value={formData.actividad}
                onChange={handleChange}
                className="col-span-3"
                required
              />
            </div>
          </div>
          <DialogFooter>
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose}
              disabled={isLoading}
            >
              Cancelar
            </Button>
            <Button 
              type="submit"
              disabled={isLoading || !formData.hora || !formData.actividad}
            >
              {isLoading ? 'Guardando...' : 'Guardar'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}; 